// extracted by mini-css-extract-plugin
export default {"upload-outer-box":"UpdateMasterData_upload-outer-box__SxJfY","company-select":"UpdateMasterData_company-select__8TEUi","custom_button":"UpdateMasterData_custom_button__1OwTj"};